import { IGallery } from '../../types/gallery';

export function galleryMediaReducer(state: IGallery = [] as IGallery): IGallery {
  return state;
}
